import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'banner-'

export default {
  path: '/banner',
  name: 'banner',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '海报轮播',
      },
      component: () => import('@/views/banner/list'),
    },
  ],
}
